import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";
import { API, GALLERY_PHOTOS, MAPS_URL, track, whatsappLink } from "../lib/site";

export default function Contact() {
  const { settings } = useSite();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);
  const update = (key) => (event) => setForm({ ...form, [key]: event.target.value });

  const submit = async (event) => {
    event.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      track("enquiry_submitted", { location: "contact_page" });
      toast.success("Your message is on its way", { description: "Our team will reply within a few hours." });
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      toast.error("We could not send your message", { description: "Please call or WhatsApp us instead." });
    } finally { setSending(false); }
  };

  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[0]}
        eyebrow="Contact Us"
        lines={[<>See you</>, <em>in Anand.</em>]}
        lede="At Anand–Sojitra Road, close to Vallabh Vidyanagar and the places that make this corner of Gujarat special."
      />
      <section className="contact-section section-pad" data-testid="contact-section">
        <Reveal>
          <span className="eyebrow">Talk to us</span>
          <h2>Every enquiry,<br /><em>answered warmly.</em></h2>
          <p>Reservations are open daily from 8 AM to 10 PM. For the fastest reply, WhatsApp or call — for anything else, write to us here.</p>
          <a className="text-link" href={MAPS_URL} target="_blank" rel="noreferrer" data-testid="maps-link">Open in Google Maps <ArrowUpRight size={15} /></a>
          <div className="contact-card">
            <div><span>Call</span><a href={`tel:${settings.phone_tel}`} onClick={() => track("call_click", { location: "contact_page" })} data-testid="contact-phone">{settings.phone_display}</a></div>
            <div><span>WhatsApp</span><a href={whatsappLink("Hello Madhubhan Resort & Spa, I have a question.", settings.whatsapp)} target="_blank" rel="noreferrer" onClick={() => track("whatsapp_click", { location: "contact_page" })} data-testid="contact-whatsapp">Chat with reservations</a></div>
            <div><span>Email</span><a href={`mailto:${settings.email}`} data-testid="contact-email">{settings.email}</a></div>
            <div><span>Address</span><p data-testid="contact-address">{settings.address}</p></div>
          </div>
        </Reveal>
        <Reveal delay={0.12} className="enquiry-card">
          <span className="eyebrow">Write to us</span>
          <h3>Send an enquiry</h3>
          <form onSubmit={submit} data-testid="enquiry-form">
            <label>Your name<input value={form.name} onChange={update("name")} required placeholder="Full name" data-testid="enquiry-name" /></label>
            <div className="form-grid">
              <label>Email<input type="email" value={form.email} onChange={update("email")} required placeholder="you@email.com" data-testid="enquiry-email" /></label>
              <label>Phone<input type="tel" value={form.phone} onChange={update("phone")} required placeholder="Mobile number" data-testid="enquiry-phone" /></label>
            </div>
            <label>Message<textarea value={form.message} onChange={update("message")} required placeholder="Dates, occasion, questions…" data-testid="enquiry-message" /></label>
            <button className="primary-button full-width" disabled={sending} type="submit" data-testid="enquiry-submit">
              {sending ? "Sending…" : "Send enquiry"} <ArrowUpRight size={16} />
            </button>
          </form>
        </Reveal>
      </section>
    </main>
  );
}
